<div
  class="amount-currency-field"
  [class.amount-currency-field--error]="showError()">

  <div class="amount-currency-field__grid">
    <!-- Amount field (left) -->
    <app-input
      [enableCurrencyFormatting]="true"
      [label]="label()"
      [placeholder]="placeholder()"
      [required]="required()"
      [type]="'text'"
      [disabled]="isDisabled()"
      [hasError]="false"
      (valueChange)="onAmountChange($event)"
      (blur)="onAmountBlur()"
    />

    <!-- Currency dropdown (right) -->
    <app-search-field
      [label]="''"
      [placeholder]="currencyPlaceholder()"
      [required]="required()"
      [showRequiredText]="false"
      [dropdownItems]="currencyItems()"
      [value]="getCurrencyLabel()"
      [disabled]="isCurrencyDisabled()"
      (itemSelected)="onCurrencySelected($event)"
      (valueChange)="onCurrencyValueChange($event)"
      (blurred)="onCurrencyBlurred()"
    />
  </div>

  <!-- Unified error message -->
  @if (showError() && errorMessage()) {
    <p class="amount-currency-field__error">{{ errorMessage() }}</p>
  }
</div>
